import { render } from "./WelcomeBack.vue?vue&type=template&id=1a3ab382&ts=true"
import script from "./WelcomeBack.vue?vue&type=script&lang=ts"
export * from "./WelcomeBack.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__